import { connect } from 'react-redux';
import { createSelector, createStructuredSelector } from 'reselect';
import FrameworkUtils from 'utils/framework';
import LanguageLocaleUtils from 'utils/LanguageLocale';
import { userSelector } from 'selectors/user/userSelector';

const { wrapHOC } = FrameworkUtils;
const { getTextFromResource, getLocaleResourceFile } = LanguageLocaleUtils;
const getText = getLocaleResourceFile('components/RichProfile/EditMyProfile/Modals/EditFlowModal/locales', 'EditFlowModal');

const fields = createSelector(
    userSelector,
    (_state, ownProps) => ownProps.content,
    createStructuredSelector({
        saveText: getTextFromResource(getText, 'saveText'),
        savedText: getTextFromResource(getText, 'savedText')
    }),
    (user, content, textResources) => {
        const isPhotosAndBio = content === 0;

        return {
            user,
            isPhotosAndBio,
            ...textResources
        };
    }
);

const withEditFlowModalProps = wrapHOC(connect(fields));

export {
    fields, withEditFlowModalProps
};
